import styled, { css } from "styled-components";

export const ProcessAlertContStyled = styled.div`
  display: flex;
  flex-direction: row;
  border: 2px solid
    ${(props) => (props.color === "red" ? "#ed5565" : "#48cfad")};
  border-radius: 14px;
  margin: 15px 0;
`;
export const RightColor = styled.div`
  width: 10%;
  /* border: 1px solid #ed5565; */
  background-color: ${(props) =>
    props.color === "red" ? "#ed5565" : "#48cfad"};
  border-radius: 0 10px 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color:#fff ;
  font-size:20px;
`;

export const AlertText = styled.div`
  width: 90%;
  margin: 5px;
  text-align: right;
`;
